import axios from '../../http_v2'
export default {
    list: (data) => {
        return axios.post('activityservice/activityhonoredguest/list', data)
    },
    add: (data) => {
        return axios.post('activityservice/activityhonoredguest/insert', data)
    },
    update: (data) => {
        return axios.post('activityservice/activityhonoredguest/update', data)
    },
    del: (data) => {
        return axios.post('activityservice/activityhonoredguest/delete', data)
    },
    delAll: (data) => {
        return axios.post('activityservice/activityhonoredguest/batchdelete', data)
    },
    import: (data) => {
        return axios.post('activityservice/activityhonoredguest/import', data)
    },
    export: (data) => {
        return axios.post('activityservice/activityhonoredguest/exportguest', data)
    }
}
